import * as urls from '@client/routes';

//@ts-ignore
export { default as settingsReducer } from './duck';
export { LazyLoadedSettingsRoute } from './LazyLoadedSettingsRoute';

export const settingsPath = urls.settingsPage;
